import React, { Component } from 'react'

import { Http } from '../../../../support';
import Loading from '../../../../facturotopia/loading/Loading';

class PaqueteFetchInfo extends Component {

  state = {
    busy: true
  }

  async componentDidMount() {
    this.setState({ busy: true });

    const { id } = this.props;

    if (id.length > 36) {
      this.props.onChange({success: false});

      return;
    }

    try {
      const response = await Http.get(`api/paquetes/${id}`);

      if (response.data.esquema === 'licencia') {
        this.props.onChange({
          success: true,
          data: response.data,
        });
      } else {
        this.props.onChange({success: false});
      }
    } catch (error) {
      this.props.onChange({
        success: false,
        error: error.data || error,
      });
    }
  }

  componentWillUnmount() {
    this.setState = () => {}
  }

  render() {
    if (this.state.busy) {
      return <Loading />
    }

    return null
  }
}

export default PaqueteFetchInfo;